var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 32,
    viewBox: "0 0 139 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13530_10054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32H0V10.6667L16 0L32 10.6667V32Z",
    fill: "url(#paint0_linear_13530_10054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52 17.3404C65.8355 15.9426 63.2222 15.2426 59.6822 15.2426H50.6533V11.3226H68.18V5.33594H42.6667V32.0026H59.6267C63.1422 32.0026 65.76 31.2426 67.4755 29.7226C69.1911 28.2026 70.0489 26.0759 70.0489 23.3404C70.0489 20.6048 69.2067 18.7404 67.5222 17.3426L67.52 17.3404ZM61.0911 26.0115C60.4311 26.5982 59.2844 26.8915 57.6489 26.8915H50.6533V20.0048H57.6489C59.2844 20.0048 60.4333 20.3137 61.0911 20.9293C61.7511 21.5448 62.08 22.3848 62.08 23.4471C62.08 24.5715 61.7511 25.4248 61.0911 26.0115Z",
    fill: "#2C2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8044 20.8098C81.5733 21.1143 81.4089 21.3498 81.3089 21.5143C81.2111 21.6787 81.12 21.8276 81.0333 21.9631H80.96V20.5343L80.9778 5.33203H72.9733V31.9987H81.6911L93.2667 16.2654C93.4867 15.9476 93.6489 15.6987 93.7511 15.5143C93.8555 15.332 93.9489 15.1543 94.0355 14.9831H94.1089C94.1089 15.1654 94.1067 15.3387 94.1 15.4965C94.0933 15.6543 94.0911 15.9365 94.0911 16.3387L94.0733 31.9987H102.058V5.33425H93.34L81.8022 20.8098H81.8044Z",
    fill: "#2C2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.153 32.0026H138.667L124.527 17.8915L137.678 5.33594H127.567L117.458 15.1337H114.582V5.33594H106.598V32.0026H114.582V21.5626H117.591L128.153 32.0026Z",
    fill: "#2C2D2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13530_10054",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#00CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#00CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#00C2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#00BCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#00AECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#00A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#009FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0098CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#0092CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#008ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#008ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#0089CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13530_10054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.667,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.10f092cc46ec09139870d7ac89938b99.svg";
export { ForwardRef as ReactComponent };